import React, { useState, useRef } from "react";
import "../../../styles/trademodals.scss";
import { t } from "../../../../../utils/i18n";

const CancelConfirmationModal = ({ onConfirm, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [confirmButtonLabel, setConfirmButtonLabel] = useState("Confirm");
  const [tryAgain, setTryAgain] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
  });

  const errorRef = useRef(null);

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCheckboxes({ ...checkboxes, [id]: checked });
  };

  const handleConfirmClick = (e) => {
    e.preventDefault();
    if (Object.values(checkboxes).every((checked) => checked)) {
      if (errorRef.current) {
        errorRef.current.style.display = "none";
      }
      setIsLoading(true);
      onConfirm();

      if (!tryAgain) {
        setTimeout(() => {
          setIsLoading(false);
          setConfirmButtonLabel("Re-Confirm");
          setTryAgain(true);
        }, 5000);
      }
      
    } else {
      if (errorRef.current) {
        errorRef.current.style.display = "block";
      }
    }
  };

  return (
    <div
      className="modal-status-cont"
      tabIndex={-1}
      aria-hidden="true"
      id="cancelConfirmModal"
      aria-labelledby="cancelConfirmModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button
            type="button"
            className="close"
            onClick={() => {onClose('cancelConfirmModal')}}
            aria-label={t("p2p.common.close")}
            disabled={isLoading}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <br/>
        </div>
        <div>
          <p className="modal-title" id="cancelConfirmModalLabel">
            {t("p2p.cancel_modal.title")}
          </p>
          <div className="trademodal-notice">
            <span>
              {" "}
              {t("p2p.cancel_modal.irreversible")}
            </span>
          </div>
          {/* terms and conditions  */}
          <div>
            <div className="trademodal-form-section">
              <small id="cancelErrorMessage" ref={errorRef} style={{ display: "none", color: "red" }}>
                {t("p2p.cancel_modal.check_all")}
              </small>
              <div className="trademodal-form-check">
                <input
                  className="trademodal-form-check-input"
                  type="checkbox"
                  id="checkbox1"
                  checked={checkboxes.checkbox1}
                  onChange={handleCheckboxChange}
                />
                <label className="trademodal-form-check-label" htmlFor="checkbox1">
                  {t("p2p.cancel_modal.check1")}
                </label>
              </div>
              <div className="trademodal-form-check">
                <input
                  className="trademodal-form-check-input"
                  type="checkbox"
                  id="checkbox2"
                  checked={checkboxes.checkbox2}
                  onChange={handleCheckboxChange}
                />
                <label className="trademodal-form-check-label" htmlFor="checkbox2">
                  {t("p2p.cancel_modal.check2")}
                </label>
              </div>
              <div className="trademodal-form-check">
                <input
                  className="trademodal-form-check-input"
                  type="checkbox"
                  id="checkbox3"
                  checked={checkboxes.checkbox3}
                  onChange={handleCheckboxChange}
                />
                <label className="trademodal-form-check-label" htmlFor="checkbox3">
                  {t("p2p.cancel_modal.check3")}
                </label>
              </div>
            </div>
          </div>
          {/* buttons */}
          <div className="modal-buttons-section">
            <div>
              <button
                type="button"
                className="modal-tradeaction-canceltradebtn"
                disabled={isLoading}
                onClick={() => {onClose('cancelConfirmModal')}}
              >
                {t("p2p.common.cancel")}
              </button>
            </div>
            <div>
              <button
                type="button"
                className="modal-tradeaction-paidbtn"
                data-dismiss="modal"
                disabled={!Object.values(checkboxes).every(Boolean)}
                onClick={handleConfirmClick}
              >
                {isLoading ? t("p2p.common.please_wait") : tryAgain ? t("p2p.cancel_modal.reconfirm") : t("p2p.common.confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelConfirmationModal;
